const corporateWelfareTree = [
  {
    label: "休假",
    options: [
      {
        value: "周末双休",
        label: "周末双休",
      },
      {
        value: "月休4天",
        label: "月休4天",
      },
      {
        value: "月休6天",
        label: "月休6天",
      },
      {
        value: "做一休一",
        label: "做一休一",
      },
      {
        value: "带薪年假",
        label: "带薪年假",
      },
    ],
  },
  {
    label: "工资补贴",
    options: [
      {
        value: "餐补",
        label: "餐补",
      },
      {
        value: "房补",
        label: "房补",
      },
      {
        value: "高温补贴",
        label: "高温补贴",
      },
      {
        value: "交通补助",
        label: "交通补助",
      },
      {
        value: "加班补助",
        label: "加班补助",
      },
      {
        value: "年底双薪",
        label: "年底双薪",
      },
      {
        value: "全勤奖",
        label: "全勤奖",
      },
      {
        value: "奖金奖励",
        label: "奖金奖励",
      },
      {
        value: "有提成",
        label: "有提成",
      },
      {
        value: "工龄奖",
        label: "工龄奖",
      },
      {
        value: "年终奖",
        label: "年终奖",
      },
      {
        value: "节假日双薪",
        label: "节假日双薪",
      },
      {
        value: "节假日三薪",
        label: "节假日三薪",
      },
    ],
  },
  {
    label: "公司福利",
    options: [
      {
        value: "不加班",
        label: "不加班",
      },
      {
        value: "免费培训",
        label: "免费培训",
      },
      {
        value: "员工团建",
        label: "员工团建",
      },
      {
        value: "员工旅游",
        label: "员工旅游",
      },
      {
        value: "包工作餐",
        label: "包工作餐",
      },
      {
        value: "包住宿",
        label: "包住宿",
      },
      {
        value: "生日福利",
        label: "生日福利",
      },
      {
        value: "有空调",
        label: "有空调",
      },
      {
        value: "有提成",
        label: "有提成",
      },
      {
        value: "实习证明",
        label: "实习证明",
      },
      {
        value: "转正机会",
        label: "转正机会",
      },
    ],
  },
  {
    label: "保险",
    options: [
      {
        value: "五险",
        label: "五险",
      },
      {
        value: "三险",
        label: "三险",
      },
      {
        value: "五险一金",
        label: "五险一金",
      },
      {
        value: "商业保险",
        label: "商业保险",
      },
    ],
  },
]

export default corporateWelfareTree

